import Hero from './components/Hero';
import About from './components/About';
import Products from './components/Products';
import Services from './components/Services';
import SeasonalPromo from './components/SeasonalPromo';
import Blog from './components/Blog';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import SeoJsonLd from '../../components/feature/SeoJsonLd';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <SeoJsonLd type="home" />
      <Navbar />
      <Hero />
      <About />
      <Products />
      <Services />
      <SeasonalPromo />
      <Blog />
      <FAQ />
      <Contact />
      <Footer />
    </div>
  );
}
